import react from "react";
import './Exhibitions_Content.css'
import { Link } from "react-router-dom";

const Exhibitions_Content = () => {
    const ExhibitionsList = [
        { img: '/Assets/Exhibitions/exhibition1.jpg', title: 'HGH India', location: 'Mumbai', Description: 'HGH India, the annual trade show for home textiles, home decor, houseware and gifts. This trade show designed exclusively to connect its exhibitors with the Indian retail trade, distribution channels, brand representatives.', link: '/Exhibitions/hgh-exhibition' },
        { img: '/Assets/Exhibitions/exhibition2.jpg', title: 'ACE Tech', location: 'Delhi, Mumbai, Kolkata, Surat, Bangalore, Hyderabad', Description: 'ACETECH is a leading trade fair in Asia for architecture, building materials, innovation and design and only third-of-its-kind in the world. This unique forum offers opportunities to not just exhibit but also to create a long-lasting impression on the decision makers of the architecture, building materials, innovation and design industries.', link: '/Exhibitions/ace-tech' },
        { img: '/Assets/Exhibitions/exhibition3.jpg', title: 'Index', location: 'Mumbai', Description: "Index is a leading international trade fair and India's largest focused commercial platform on interiors, architecture and design, bringing together suppliers and buyers in a design atmosphere.The industry has grown, new and big international players have entered the markets, and the scope for doing business has evolved with both exhibitors and organizers becoming more professional.", link: '/Exhibitions/index-mumbai' },
    ]

    return (
        <>
            <div className="ExhibitionsList_container">
                <div className="pg_content_warpper">
                    <div className="Page-Main_Dec">
                        <h1 className="Page-title_LowerCase">Exhibitions</h1>
                    </div>
                    <div className="Exhibitions_pg_cards">
                        {ExhibitionsList.map((Exhibitions, index) => (
                            <>
                                <div className="Exhibitions_card" key={index} id={`Exhibitions_card${index}`}>
                                    <div className="ExhibitionsCard_left">
                                        <img src={Exhibitions.img} />
                                    </div>
                                    <div className="ExhibitionsCard_right">
                                        <h2 className="ExhibitionsCard_title">{Exhibitions.title}</h2>
                                        <h3 className="ExhibitionsCard_location">{Exhibitions.location}</h3>
                                        <p>{Exhibitions.Description}</p>
                                        <Link to={`${Exhibitions.link}`} className="ExhibitionsCard_link">View Photos</Link>
                                    </div>
                                </div>
                                {index !== ExhibitionsList.length - 1 && (
                                    <div style={{ borderTop: "1px solid #ccc" }}></div>
                                )}
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Exhibitions_Content;